import React from "react";
import { connect } from "react-redux";
import { Route, Switch, Redirect } from "react-router-dom";

import {
  selectCurrentOrganization,
  selectUser,
  selectLoggedAs
} from "Selectors";
import { checkAuthentication } from "./checkAuthentication";

import {
  isManagerAccess,
  isCollaboratorAccess,
  isSupervisorAccess,
  isAdminAccess,
  isSuperAdminAccess
} from "Utils";

import TimeSheetPage from "../components/TimeSheet/TimeSheetPage";
import CollaboratorTimeSheetPage from "../components/TimeSheet/CollaboratorTimeSheetPage";
import BudgetPage from "../components/Budget/BudgetPage";
import PeriodFinancialPage from "../components/Financial/PeriodFinancialPage";
import CapacityPlaningCollaboratorPage from "../components/CapacityPlanning/CapacityPlaningCollaboratorPage";
import CapacityPlaningProductionPage from "../components/CapacityPlanning/CapacityPlaningProductionPage";
import CollaboratorSettingPage from "../components/CollaboratorSetting/CollaboratorSettingPage";
import CollaboratorSpacePage from "../components/CollaboratorSpace/CollaboratorSpacePage";
import CollaboratorClientsFoldersPage from "../components/CollaboratorClientsFolders/CollaboratorClientsFoldersPage";
import CategoryStatisticsPage from "../components/CategoryStatistics/CategoryStatisticsPage";
import CategorySettingsPage from "../components/CategorySettings/CategorySettingsPage";
import CalendarSettingsPage from "../components/CalendarSettings/CalendarSettingsPage";
import BudgetSettingsPage from "../components/BudgetSettings/BudgetSettingsPage";
import TaskTypeSettingsPage from "../components/TaskType/TaskTypeSettingsPage";
import CalendarTablePage from "../components/CalendarTable/CalendarTablePage";
import ParameterSettingsPage from "../components/ParameterSettings/ParameterSettingsPage";
import ClientsVuePage from "../components/ClientsList/ClientsVuePage";
import NotFoundV2 from "../components/NotFound/NotFoundV2";
import AuthorizationsPage from "../components/Authorizations/AuthorizationsPage";
import DynamicTable from "../components/DynamicTable/DynamicTable";
import CollaboratorCalendarPage from "../components/CollaboratorCalendar/CollaboratorCalendarPage";

const Home = connect(state => ({
  currentOrganization: selectCurrentOrganization(state),
  user: selectUser(state),
  loggedAs: selectLoggedAs(state),
  spaceAs: state.auth && state.auth.spaceAs
}))(({ loggedAs, spaceAs, user }) => {
  return isManagerAccess(loggedAs, spaceAs) ||
    isAdminAccess(loggedAs, spaceAs) ||
    isSuperAdminAccess(loggedAs, spaceAs) ? (
    <Redirect to={`/clients`} />
  ) : isCollaboratorAccess(loggedAs, spaceAs) ? (
    <Redirect to={`/collaborator-space`} />
  ) : isSupervisorAccess(loggedAs) ? (
    <Redirect to={`/clients`} />
  ) : (
    <Redirect to={`/not_found`} />
  );
});

export const urls = {
  index: "/",
  clients: "/clients",
  collaboratorTimeSheet: "/collaborator-time-sheet/:id?/:name?",
  timeSheet: "/time-sheet/:id?/:name?/:startDate?/:endDate?",
  budgetSheet: "/budget",
  budgetSetting: "/budget-setting",
  financialSheet: "/financial",
  capacityPlaningCollaborator:
    "/capacity-planing/collaborator/:name?/:id?/:tab?",
  capacityPlaningProduction: "/capacity-planing/production",
  categoryStatistics: "/category-statistics",
  categorySettings: "/category-settings",
  taskTypeSettings: "/task-types",
  collaboratorSetting: "/collaborators-settings/:name?",
  collaboratorSpace: "/collaborator-space",
  collaboratorCalendar: "/collaborator-calendar",
  collaboratorClientsFolders: "/collaborator-folders",
  calendarSettings: "/calendar-settings",
  calendarTable: "/calendar/:name?/:id?",
  parameterSettings: "/parameter-settings",
  authorizations: "/authorizations",
  dynamicTable: "/dynamic-table",
  notFound: "*"
};

export const getRoutes = (currentOrganization, spaceAs) => {
  const authorisation =
    currentOrganization && currentOrganization.authorisation;
  const loggedAs = authorisation && authorisation.role;
  let accessAdmin = currentOrganization
    ? currentOrganization.userType === "ADMIN" ||
      currentOrganization.userType === "ADMIN_SUPERVISOR"
    : false;

  console.log("team", loggedAs, spaceAs);

  if (
    (loggedAs && spaceAs && isManagerAccess(loggedAs, spaceAs)) ||
    (loggedAs && isSupervisorAccess(loggedAs)) ||
    (loggedAs && spaceAs && isAdminAccess(loggedAs, spaceAs)) ||
    (loggedAs && spaceAs && isSuperAdminAccess(loggedAs, spaceAs)) ||
    accessAdmin
  ) {
    return (
      <Switch>
        <Route exact path="/" component={checkAuthentication(Home)} />
        <Route
          path={urls.timeSheet}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(TimeSheetPage)}
        />
        <Route
          path={urls.collaboratorTimeSheet}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(CollaboratorTimeSheetPage)}
        />
        <Route
          path={urls.clients}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(ClientsVuePage)}
        />
        <Route
          path={urls.budgetSheet}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(BudgetPage)}
        />
        <Route
          path={urls.budgetSetting}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(BudgetSettingsPage)}
        />
        <Route
          path={urls.categoryStatistics}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(CategoryStatisticsPage)}
        />
        <Route
          path={urls.capacityPlaningCollaborator}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(CapacityPlaningCollaboratorPage)}
        />
        <Route
          path={urls.capacityPlaningProduction}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(CapacityPlaningProductionPage)}
        />
        <Route
          path={urls.categorySettings}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(CategorySettingsPage)}
        />
        <Route
          path={urls.taskTypeSettings}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(TaskTypeSettingsPage)}
        />
        <Route
          path={urls.collaboratorSetting}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(CollaboratorSettingPage)}
        />
        <Route
          path={urls.financialSheet}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(PeriodFinancialPage)}
        />
        <Route
          path={urls.calendarSettings}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(CalendarSettingsPage)}
        />
        <Route
          path={urls.calendarTable}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(CalendarTablePage)}
        />
        <Route
          path={urls.parameterSettings}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(ParameterSettingsPage)}
        />
        <Route
          path={urls.authorizations}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(AuthorizationsPage)}
        />
        <Route
          path={urls.dynamicTable}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(DynamicTable)}
        />
        <Route
          path={urls.collaboratorSpace}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(CollaboratorSpacePage)}
        />
        <Route
          path={urls.collaboratorCalendar}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(CollaboratorCalendarPage)}
        />
        <Route
          path={urls.collaboratorClientsFolders}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(CollaboratorClientsFoldersPage)}
        />{" "}
        <Route
          path="*"
          component={() => <NotFoundV2 errorPageType={"ERROR_404"} />}
        />
      </Switch>
    );
  } else if (loggedAs && spaceAs && isCollaboratorAccess(loggedAs, spaceAs)) {
    return (
      <Switch>
        <Route exact path="/" component={checkAuthentication(Home)} />
        <Route
          path={urls.collaboratorTimeSheet}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(CollaboratorTimeSheetPage)}
        />
        <Route
          path={urls.collaboratorSpace}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(CollaboratorSpacePage)}
        />
        <Route
          path={urls.collaboratorCalendar}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(CollaboratorCalendarPage)}
        />

        <Route
          path={urls.collaboratorClientsFolders}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(CollaboratorClientsFoldersPage)}
        />
        <Route
          path={urls.capacityPlaningCollaborator}
          onUpdate={() => window.scrollTo(0, 0)}
          component={checkAuthentication(CapacityPlaningCollaboratorPage)}
        />
        <Route
          path="*"
          component={() => <NotFoundV2 errorPageType={"ERROR_404"} />}
        />
      </Switch>
    );
  } else {
    return (
      <Switch>
        <Route exact path="/" component={checkAuthentication(Home)} />

        <Route
          path="*"
          component={() => <NotFoundV2 errorPageType={"ERROR_404"} />}
        />
      </Switch>
    );
  }
};



// WEBPACK FOOTER //
// ./src/router/getRoutes.js